import { createReducer, on } from "@ngrx/store";
import { Household } from "../../../shared/models/household.model";
import * as HouseholdActions from './household.actions';

export interface HouseholdState {
    households: Household[];
    activeHousehold: Household | null;
    isLoading: boolean;
    error: any;
  }
  
  export const initialState: HouseholdState = {
    households: [],
    activeHousehold: null,
    isLoading: false,
    error: null,
  };
  
  export const householdReducer = createReducer(
    initialState,
  
    on(HouseholdActions.loadHouseholds, state => ({
      ...state,
      isLoading: true,
      error: null
    })),
  
    on(HouseholdActions.loadHouseholdsSuccess, (state, { households }) => ({
      ...state,
      households,
      isLoading: false,
      activeHousehold: households.length > 0 ? households[0] : null // default to first one
    })),
  
    on(HouseholdActions.loadHouseholdsFailure, (state, { error }) => ({
      ...state,
      isLoading: false,
      error
    })),
  
    on(HouseholdActions.setActiveHousehold, (state, { household }) => ({
      ...state,
      activeHousehold: household
    })),
  
    on(HouseholdActions.clearHouseholds, () => initialState)
  );